import {
  FETCH_CALIFICACIONES,
  FETCH_MOSTRAR_CALIFICACIONES,
  SET_CURRENT_CALIFICACIONES_STATUS,
  RESET_TO_LAST_SAFE_CONFIGURATION,
} from '../constants/index';

const initialState = {
  calificaciones: null,
  mostrarCalificaciones: false,
  currentSavedStatus: false,
};

export default function (state = initialState, action) {
  const newState = { ...state };

  switch (action.type) {
    case FETCH_CALIFICACIONES:
      newState.calificaciones = action.data;
      return newState;
    case FETCH_MOSTRAR_CALIFICACIONES:
      newState.mostrarCalificaciones = action.data;
      return newState;
    case SET_CURRENT_CALIFICACIONES_STATUS:
      newState.currentSavedStatus = action.data;
      return newState;
    case RESET_TO_LAST_SAFE_CONFIGURATION:
      newState.mostrarCalificaciones = newState.currentSavedStatus;
      return newState;
    default:
      return newState;
  }
}
